import React from 'react';
import type {ThesaurusId} from 'services/thesaurus/types';
import {ThesaurusesGate} from 'services/thesaurus';
import {MultiThesaurusEdit} from 'feature/editMultiThesaurus';
import {useMultiThesaurusEditContext} from './hooks/useMultiThesaurusEditContext';

type Props = {
  onClose: () => Promise<void>;
};

const thesaurusIds: ThesaurusId[] = ['thema'];

export const MultiThesaurusEditContainer: React.FC<Props> = ({onClose: _}) => {
  const {sourceField, setSourceValue, closeExtension} =
    useMultiThesaurusEditContext();

  return (
    <ThesaurusesGate thesauruses={thesaurusIds}>
      {thesaurusIds ? (
        <MultiThesaurusEdit
          fieldConfig={sourceField?.fieldConfig}
          thesaurusValue={sourceField?.currentValue}
          onSetSourceValue={setSourceValue}
          onClose={closeExtension}
        />
      ) : null}
    </ThesaurusesGate>
  );
};
